import { render, staticRenderFns } from "./curveRecommend.vue?vue&type=template&id=76227602&scoped=true"
import script from "./curveRecommend.vue?vue&type=script&lang=js"
export * from "./curveRecommend.vue?vue&type=script&lang=js"
import style0 from "./curveRecommend.vue?vue&type=style&index=0&id=76227602&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76227602",
  null
  
)

export default component.exports